(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["night-dualsilk-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('night-dualsilk-gallery')) {
  customElements.define('night-dualsilk-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.viewport = this.querySelector('.night-dualsilk-gallery__viewport');
      this.buttons = [...this.querySelectorAll('[data-slide]')];
      this.variants = JSON.parse(this.querySelector('[data-dualsilk-variants]').textContent);
      this.messages = JSON.parse(this.querySelector('[data-dualsilk-messages]').textContent);
      this.foldedPhotos = JSON.parse(this.querySelector('[data-dualsilk-folded]').textContent);
      this.openingPhotos = JSON.parse(this.querySelector('[data-dualsilk-opening]').textContent);
      this.section = this.closest('.js-product');
      this.currentColor = this.dataset.color;
      this.buttons.forEach(button => button.addEventListener('click', () => this.go(Number(button.dataset.slide))));
      this.viewport.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          const i = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
          this.buttons.forEach((button, n) => button.setAttribute('aria-pressed', String(n === i)));
          this.querySelector('[data-gallery-status]').textContent = this.messages.position.replace('__INDEX__', String(i + 1));
        });
      }, {passive:true});
      this.viewport.addEventListener('keydown', event => {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const i = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
        const last = this.buttons.length - 1;
        this.go(event.key === 'Home' ? 0 : event.key === 'End' ? last : Math.max(0, Math.min(last, i + (event.key === 'ArrowRight' ? 1 : -1))));
      });
      this.onVariant = event => {
        const data = this.variants[event.detail.variant?.id];
        if (!data) return;
        const photo = this.querySelector('.night-dualsilk-color-image');
        photo.removeAttribute('srcset');
        photo.src = data.src;
        photo.alt = data.alt;
        const thumb = this.querySelector('.night-dualsilk-color-thumb');
        thumb.removeAttribute('srcset');
        thumb.src = data.thumb;
        this.querySelector('[data-color-caption]').textContent = this.messages.color.replace('__COLOR__', data.color);
        const foldedData = this.foldedPhotos[data.color];
        if (foldedData) {
          const foldedPhoto = this.querySelector('.night-dualsilk-folded-image');
          foldedPhoto.removeAttribute('srcset');
          foldedPhoto.src = foldedData.src;
          foldedPhoto.alt = foldedData.alt;
          const foldedThumb = this.querySelector('.night-dualsilk-folded-thumb');
          foldedThumb.removeAttribute('srcset');
          foldedThumb.src = foldedData.thumb;
        }
        const openingData = this.openingPhotos[data.color];
        if (openingData) {
          const openingPhoto = this.querySelector('.night-dualsilk-opening-image');
          openingPhoto.removeAttribute('srcset');
          openingPhoto.src = openingData.src;
          openingPhoto.alt = openingData.alt;
          const openingThumb = this.querySelector('.night-dualsilk-opening-thumb');
          openingThumb.removeAttribute('srcset');
          openingThumb.src = openingData.thumb;
        }
        const activeSlide = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
        if (data.color !== this.currentColor && ![1, 5].includes(activeSlide)) this.go(0);
        this.currentColor = data.color;
      };
      this.section?.addEventListener('on:variant:change', this.onVariant);
    }
    disconnectedCallback() {
      this.section?.removeEventListener('on:variant:change', this.onVariant);
      cancelAnimationFrame(this.frame);
      this.ready = false;
    }
    go(index) {
      this.viewport.scrollTo({left:index * this.viewport.clientWidth, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["night-eye-mask-pack"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('night-eye-mask-pack')){
  customElements.define('night-eye-mask-pack',class extends HTMLElement{
    connectedCallback(){
      this.form=this.closest('.js-product');
      if(!this.form||this.onVariant)return;
      this.previewView=new URL(window.location.href).searchParams.get('view');
      this.onVariant=(event)=>{
        this.update(event.detail?.variant?.id);
        if(this.previewView==='silk-eye-mask'){
          const url=new URL(window.location.href);url.searchParams.set('view',this.previewView);
          window.history.replaceState({},'',url);
        }
      };
      this.form.addEventListener('on:variant:change',this.onVariant);
      const picker=this.form.querySelector('variant-picker');
      this.update(picker?.getSelectedVariant?.()?.id||this.dataset.initial);
    }
    update(id){this.querySelectorAll('[data-eye-variant]').forEach(el=>{el.hidden=el.dataset.eyeVariant!==String(id);});}
    disconnectedCallback(){this.form?.removeEventListener('on:variant:change',this.onVariant);this.onVariant=null;}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["night-mask-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('night-mask-gallery')){
  customElements.define('night-mask-gallery',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;this.viewport=this.querySelector('.night-mask-gallery__viewport');
      this.buttons=[...this.querySelectorAll('[data-mask-slide]')];
      this.messages=JSON.parse(this.querySelector('[data-mask-messages]').textContent);
      this.variants=JSON.parse(this.querySelector('[data-mask-variants]').textContent);
      this.buttons.forEach(button=>button.addEventListener('click',()=>this.go(Number(button.dataset.maskSlide))));
      this.viewport.addEventListener('scroll',()=>{
        cancelAnimationFrame(this.frame);
        this.frame=requestAnimationFrame(()=>{
          const i=Math.round(this.viewport.scrollLeft/this.viewport.clientWidth);
          this.buttons.forEach((b,n)=>b.setAttribute('aria-pressed',String(i===n)));
          this.querySelector('[data-mask-status]').textContent=this.messages.position.replace('__INDEX__',String(i+1));
        });
      },{passive:true});
      this.viewport.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();
        const i=Math.round(this.viewport.scrollLeft/this.viewport.clientWidth),last=this.buttons.length-1;
        this.go(event.key==='Home'?0:event.key==='End'?last:Math.max(0,Math.min(last,i+(event.key==='ArrowRight'?1:-1))));
      });
      this.section=this.closest('.js-product');
      this.onVariant=event=>{const count=this.variants[event.detail?.variant?.id];if(count)this.querySelector('[data-mask-contents]').textContent=this.messages.contents[String(count)];};
      this.section?.addEventListener('on:variant:change',this.onVariant);
    }
    disconnectedCallback(){this.section?.removeEventListener('on:variant:change',this.onVariant);cancelAnimationFrame(this.frame);this.ready=false;}
    go(i){this.viewport.scrollTo({left:this.viewport.clientWidth*i,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["night-satin-eye-mask-pack"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('night-satin-eye-pack')){
  customElements.define('night-satin-eye-pack',class extends HTMLElement{
    connectedCallback(){
      this.form=this.closest('.js-product');
      if(!this.form||this.onVariant)return;
      this.previewView=new URL(window.location.href).searchParams.get('view');
      this.onVariant=(event)=>{
        this.update(event.detail?.variant?.id);
        if(this.previewView==='satin-eye-mask'){
          const url=new URL(window.location.href);url.searchParams.set('view',this.previewView);
          window.history.replaceState({},'',url);
        }
      };
      this.form.addEventListener('on:variant:change',this.onVariant);
      const picker=this.form.querySelector('variant-picker');
      this.update(picker?.getSelectedVariant?.()?.id||this.dataset.initial);
    }
    update(id){this.querySelectorAll('[data-satin-eye-variant]').forEach(el=>{el.hidden=el.dataset.satinEyeVariant!==String(id);});}
    disconnectedCallback(){this.form?.removeEventListener('on:variant:change',this.onVariant);this.onVariant=null;}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["night-satin-pack"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('night-satin-pack')){
  class NightSatinPack extends HTMLElement{
    connectedCallback(){
      this.productSection=this.closest('.js-product');
      if(!this.productSection||this.variantListener)return;
      this.variantListener=(event)=>this.showVariant(event.detail?.variant?.id);
      this.productSection.addEventListener('on:variant:change',this.variantListener);
      const picker=this.productSection.querySelector('variant-picker');
      const selected=typeof picker?.getSelectedVariant==='function'?picker.getSelectedVariant():null;
      this.showVariant(selected?.id||this.dataset.initialVariant);
    }
    showVariant(id){this.querySelectorAll('[data-satin-variant]').forEach((el)=>{el.hidden=el.dataset.satinVariant!==String(id);});}
    disconnectedCallback(){this.productSection?.removeEventListener('on:variant:change',this.variantListener);this.variantListener=null;}
  }
  customElements.define('night-satin-pack',NightSatinPack);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["night-scrunchie-pack-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('night-scrunchie-pack')) {
  class NightScrunchiePack extends HTMLElement {
    connectedCallback() {
      this.productSection = this.closest('.js-product');
      if (!this.productSection || this.variantListener) return;
      this.variantListener = (event) => this.showVariant(event.detail?.variant?.id);
      this.productSection.addEventListener('on:variant:change', this.variantListener);
      const picker = this.productSection.querySelector('variant-picker');
      const selected = typeof picker?.getSelectedVariant === 'function' ? picker.getSelectedVariant() : null;
      this.showVariant(selected?.id || this.dataset.initialVariant);
    }
    showVariant(id) {
      this.querySelectorAll('[data-night-variant]').forEach((el) => {
        el.hidden = el.dataset.nightVariant !== String(id);
      });
    }
    disconnectedCallback() {
      this.productSection?.removeEventListener('on:variant:change', this.variantListener);
      this.variantListener = null;
    }
  }
  customElements.define('night-scrunchie-pack', NightScrunchiePack);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["night-silk-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('night-silk-purchase')) {
    customElements.define('night-silk-purchase', class extends HTMLElement {
      connectedCallback() {
        if (this.variantHandler) return;
        this.scope = this.closest('.section-main-product');
        this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        this.variantHandler = (event) => {
          if (!this.closest('.js-product').contains(event.target)) return;
          const variant = event.detail.variant;
          const details = variant && this.data.variants[variant.id];
          this.querySelector('.night-silk-status').textContent = details ? details.status : this.data.unavailable;
          this.querySelector('.night-silk-dispatch').hidden = !details || !details.dispatch;
          this.scope.querySelectorAll('.night-silk-sticky-price').forEach((price) => {
            price.textContent = details ? details.price.replace(/<[^>]*>/g, '') : '';
          });
        };
        this.scope.addEventListener('on:variant:change', this.variantHandler);
      }
      disconnectedCallback() {
        this.scope?.removeEventListener('on:variant:change', this.variantHandler);
        this.variantHandler = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["night-skincare-variant-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('night-variant-content')) {
    class NightVariantContent extends HTMLElement {
      connectedCallback() {
        this.productSection = this.closest('.js-product');
        if (!this.productSection || this.variantListener) return;
        this.variantListener = (event) => {
          const variant = event.detail?.variant;
          this.showVariant(variant?.id);
          if (variant && this.dataset.mode === 'hero') {
            const gallery = this.closest('media-gallery');
            const packSlide = this.closest('.slider__item[data-media-id]');
            if (typeof gallery?.setActiveMedia === 'function') gallery.setActiveMedia(packSlide?.dataset.mediaId || 'night-1', true);
          }
        };
        this.productSection.addEventListener('on:variant:change', this.variantListener);
        const picker = this.productSection.querySelector('variant-picker');
        const selected = typeof picker?.getSelectedVariant === 'function' ? picker.getSelectedVariant() : null;
        this.showVariant(selected?.id || this.dataset.initialVariant);
      }
      showVariant(variantId) {
        this.querySelectorAll('[data-night-variant]').forEach((element) => {
          element.hidden = element.dataset.nightVariant !== String(variantId);
        });
        if (this.dataset.mode === 'hero') {
          const imageLink = this.querySelector('[data-night-variant]:not([hidden]) .show-gallery');
          const zoomThumb = this.closest('media-gallery')?.galleryModal?.querySelector('[data-night-pack-zoom]');
          if (imageLink && zoomThumb) {
            zoomThumb.dataset.zoomUrl = imageLink.getAttribute('href');
            const thumbImage = zoomThumb.querySelector('img');
            thumbImage.src = imageLink.dataset.zoomThumbnail;
            thumbImage.removeAttribute('srcset');
            thumbImage.alt = imageLink.querySelector('img')?.alt || '';
          }
        }
      }
      disconnectedCallback() {
        this.productSection?.removeEventListener('on:variant:change', this.variantListener);
        this.variantListener = null;
      }
    }
    customElements.define('night-variant-content', NightVariantContent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["night-skinny-pack-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('night-scrunchie-pack')) {
  class NightScrunchiePack extends HTMLElement {
    connectedCallback() {
      this.productSection = this.closest('.js-product');
      if (!this.productSection || this.variantListener) return;
      this.variantListener = (event) => this.showVariant(event.detail?.variant?.id);
      this.productSection.addEventListener('on:variant:change', this.variantListener);
      const picker = this.productSection.querySelector('variant-picker');
      const selected = typeof picker?.getSelectedVariant === 'function' ? picker.getSelectedVariant() : null;
      this.showVariant(selected?.id || this.dataset.initialVariant);
    }
    showVariant(id) {
      this.querySelectorAll('[data-night-variant]').forEach((el) => {
        el.hidden = el.dataset.nightVariant !== String(id);
      });
    }
    disconnectedCallback() {
      this.productSection?.removeEventListener('on:variant:change', this.variantListener);
      this.variantListener = null;
    }
  }
  customElements.define('night-scrunchie-pack', NightScrunchiePack);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["night-sleep-set-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('night-sleep-set-gallery'))customElements.define('night-sleep-set-gallery',class extends HTMLElement{
 connectedCallback(){
  this.form=this.closest('.js-product');
  this.frame=this.querySelector('.night-set-gallery__frame');
  this.variant=this.dataset.initialVariant;
  this.color=this.querySelector(`[data-set-hero="${this.variant}"]`)?.dataset.setColor;
  this.slide=0;
  this.slides=Array.from(this.querySelectorAll('[data-slide]'),b=>Number(b.dataset.slide));
  this.select=e=>{const b=e.target.closest('[data-slide]');if(b&&this.contains(b))this.show(Number(b.dataset.slide));};
  this.change=e=>{if(!e.detail?.variant?.id)return;this.variant=String(e.detail.variant.id);this.color=this.querySelector(`[data-set-hero="${this.variant}"]`)?.dataset.setColor;this.show(this.slide);this.syncThumbnail();this.dispatchEvent(new CustomEvent('night:set-color-change',{bubbles:true,detail:{color:this.color}}));};
  this.keys=e=>{if(!e.target.closest('[data-slide]')||!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();let i=this.slides.indexOf(this.slide);i=e.key==='Home'?0:e.key==='End'?this.slides.length-1:(i+(e.key==='ArrowRight'?1:-1)+this.slides.length)%this.slides.length;this.show(this.slides[i]);this.querySelector(`[data-slide="${this.slide}"]`)?.focus();};
  this.touchStart=e=>{this.videoTouch=!!e.target.closest('video');this.startX=e.changedTouches[0].screenX;this.startY=e.changedTouches[0].screenY;};
  this.touchEnd=e=>{if(this.videoTouch)return;const dx=e.changedTouches[0].screenX-this.startX,dy=e.changedTouches[0].screenY-this.startY;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)){const i=this.slides.indexOf(this.slide);this.show(this.slides[(i+(dx<0?1:-1)+this.slides.length)%this.slides.length]);}};
  this.addEventListener('click',this.select);
  this.addEventListener('keydown',this.keys);
  this.form?.addEventListener('on:variant:change',this.change);
  this.frame?.addEventListener('touchstart',this.touchStart,{passive:true});
  this.frame?.addEventListener('touchend',this.touchEnd,{passive:true});
 }
 show(n){if(!this.slides.includes(n))return;this.slide=n;this.querySelectorAll('[data-set-hero]').forEach(el=>el.hidden=n!==0||el.dataset.setHero!==this.variant);this.querySelectorAll('[data-set-slide]').forEach(el=>el.hidden=Number(el.dataset.setSlide)!==n||(!!el.dataset.setColor&&el.dataset.setColor!==this.color));this.querySelectorAll('[data-slide]').forEach(el=>el.setAttribute('aria-pressed',String(Number(el.dataset.slide)===n)));const video=this.querySelector('video');if(video){if(n===5&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){video.play().catch(()=>{});}else{video.pause();}}}
 syncThumbnail(){for(const n of [0,2,4]){const photo=n===0?this.querySelector(`[data-set-hero="${this.variant}"] img`):this.querySelector(`[data-set-slide="${n}"][data-set-color="${this.color}"] img`),thumb=this.querySelector(`[data-slide="${n}"] img`);if(!photo||!thumb)continue;for(const attr of ['src','srcset']){const value=photo.getAttribute(attr);if(value)thumb.setAttribute(attr,value);}}}
 disconnectedCallback(){this.querySelector('video')?.pause();this.removeEventListener('click',this.select);this.removeEventListener('keydown',this.keys);this.form?.removeEventListener('on:variant:change',this.change);this.frame?.removeEventListener('touchstart',this.touchStart);this.frame?.removeEventListener('touchend',this.touchEnd);}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["night-sleep-set-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('night-sleep-set-size-guide')) {
  customElements.define('night-sleep-set-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.dialog = this.querySelector('dialog');
      this.opener = this.closest('fieldset').querySelector('.night-set-size-guide__open');
      this.opener.addEventListener('click', () => {
        this.dialog.showModal();
        document.documentElement.classList.add('night-size-guide-open');
      }, options);
      this.querySelector('.night-set-size-guide__close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('night-size-guide-open');
        this.opener.focus({ preventScroll: true });
      }, options);
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      document.documentElement.classList.remove('night-size-guide-open');
      this.abort?.abort();
      this.abort = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["night-sleep-set-value"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('night-sleep-set-value'))customElements.define('night-sleep-set-value',class extends HTMLElement{
 connectedCallback(){this.form=this.closest('.js-product');this.preview=new URL(location.href).searchParams.get('view');this.change=e=>{this.querySelectorAll('[data-set-variant]').forEach(el=>el.hidden=el.dataset.setVariant!==String(e.detail?.variant?.id));if(this.preview==='silk-sleep-set'){const url=new URL(location.href);url.searchParams.set('view',this.preview);history.replaceState({},'',url);}};this.form.addEventListener('on:variant:change',this.change);}
 disconnectedCallback(){this.form?.removeEventListener('on:variant:change',this.change);}
});
  } catch(e) { console.error(e); }
})();

})();
